import { ThemeProvider } from 'styled-components';
import { useViewContainer } from './useViewContainer';
import { LayoutTemplateViewContainer } from './LayoutTemplateViewContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const FramedViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();
  if (!ViewComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: {
      embedded: true
    },
    children: /*#__PURE__*/_jsx(LayoutTemplateViewContainer, Object.assign({
      showLogo: false,
      showProgressIndicator: false,
      StepViewComponent: ViewComponent
    }, viewContainerProps))
  });
};